import { Component, OnInit, signal, inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { MenuItem } from '@card-software/library';
import { UserAuthenticationService } from './services/user-authentication.service';
import { environment } from '../environments/environment';
import { MessageService } from 'primeng/api';
import { GlobalMessageUtil } from './utils/global-message-util';
import { TranslateService } from '@ngx-translate/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  private router = inject(Router);
  private userAuthenticationService = inject(UserAuthenticationService);
  private messageService = inject(MessageService);
  private translate = inject(TranslateService);

  title = 'asc-ui';
  isLoginPage = false;
  readonly environment = environment.environment;

  languageOptions = signal(['es', 'en']);
  languageSelection = new FormControl('en');

  menuItems: MenuItem[] = [];

  constructor() {
    this.translate.setDefaultLang('en');

    GlobalMessageUtil.init(this.messageService);
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.isLoginPage = event.url === '/login';
      }
    });
  }

  ngOnInit(): void {
    this.loadMenuItems();

    this.languageSelection.valueChanges.subscribe((lang) => {
      this.translate.use(lang ?? 'en');
      this.loadMenuItems();
    });
  }

  loadMenuItems(): void {
    const translationKeys = {
      assetServiceCenter: 'Side_bar.AssetServiceCenter',
      maintenance: 'Side_bar.Maintenance',
      reports: 'Side_bar.Reports',
    };

    this.translate.get(Object.values(translationKeys)).subscribe((translations) => {
      this.menuItems = [
        {
          displayName: translations[translationKeys.assetServiceCenter],
          routerLink: '/dashboard',
          redirect: true,
        },
        {
          displayName: translations[translationKeys.maintenance],
          routerLink: '/maintenance',
          redirect: false,
          children: [
            {
              displayName: translations[translationKeys.reports],
              routerLink: 'maintenance/reports',
              redirect: true,
            },
          ],
        },
      ];
    });
  }

  get isLoggedIn() {
    return this.userAuthenticationService.isUserAuthenticated;
  }

  get userLite() {
    return this.userAuthenticationService.userLite;
  }

  get userToken() {
    return this.userAuthenticationService.getStoredJwtToken() || '';
  }

  get showSidebar(): boolean {
    const isLoginPage = this.router.url.includes('/login');
    return this.userAuthenticationService.isUserAuthenticated && !isLoginPage;
  }

  onLogout() {
    this.userAuthenticationService.logout();
  }
}
